import { telemetryService } from 'npo-common';
import localeService from 'src/dataServices/LocaleService';
import { FeedbackSubmission, IContactUsSubmissionFields } from 'src/state/contactus/types';

function withThreadId(properties: Record<string, string>, threadId?: string) {
  return threadId ? { ...properties, ThreadId: threadId } : properties;
}

export const supportTelemetryService = {
  trackLegacyQuerySubmitted(query: string) {
    telemetryService.ai?.trackEvent({
      name: 'Contact.Query.Submitted',
      properties: {
        Query: query,
        UserLocale: localeService.getlocale() ?? ''
      }
    });
  },

  trackFeedbackClicked(responseId: string, polarity: 'positive' | 'negative', threadId?: string) {
    telemetryService.ai?.trackEvent({
      name: 'Feedback.Clicked',
      properties: withThreadId(
        {
          ResponseId: responseId,
          Polarity: polarity
        },
        threadId
      )
    });
  },

  trackFeedbackSubmitted(submission: FeedbackSubmission) {
    telemetryService.ai?.trackEvent({
      name: 'Feedback.Submitted',
      properties: withThreadId(
        {
          ResponseId: submission.responseId,
          Polarity: submission.polarity,
          ReasonCode: submission.reasonCode,
          ReasonCodeLabel: submission.reasonCodeLabel ?? '',
          ReasonCodeDescription: submission.reasonCodeDescription ?? '',
          Comment: submission.comment?.substring(0, 1000) ?? ''
        },
        submission.threadId
      )
    });
  },

  trackAgentChatOpened(threadId: string, context?: { sessionId?: string; pageName?: string; pageUrl?: string }) {
    telemetryService.ai?.trackEvent({
      name: 'Agent.Chat.Opened',
      properties: {
        ThreadId: threadId,
        ...(context?.sessionId ? { SessionId: context.sessionId } : {}),
        ...(context?.pageName ? { PageName: context.pageName } : {}),
        ...(context?.pageUrl ? { PageUrl: context.pageUrl } : {})
      }
    });
  },

  trackAgentTicketFormOpened(threadId: string) {
    telemetryService.ai?.trackEvent({
      name: 'Agent.Ticket.FormOpened',
      properties: { ThreadId: threadId }
    });
  },

  trackAgentTicketCreated(properties: {
    topic: string;
    description: string;
    aiGeneratedTopic: string;
    aiGeneratedDescription: string;
    turnCountBeforeTicket: number;
    role: string;
    threadId?: string;
  }) {
    telemetryService.ai?.trackEvent({
      name: 'Agent.Ticket.Created',
      properties: withThreadId(
        {
          Topic: properties.topic,
          Description: properties.description,
          AIGeneratedTopic: properties.aiGeneratedTopic,
          AIGeneratedDescription: properties.aiGeneratedDescription,
          TurnCountBeforeTicket: String(properties.turnCountBeforeTicket),
          Role: properties.role
        },
        properties.threadId
      )
    });
  },

  trackLegacyTicketSubmitted(contactUsSubmissionFields: IContactUsSubmissionFields) {
    telemetryService.ai?.trackEvent({
      name: 'Legacy.Ticket.Submitted',
      properties: {
        Category: contactUsSubmissionFields.category,
        Role: contactUsSubmissionFields.role,
        UserLocale: contactUsSubmissionFields.userLocale
      }
    });
  }
};
